import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23.395" height="31.422" viewBox="0 0 23.395 31.422">
            <g id="Group_1813" data-name="Group 1813" transform="translate(-856.874 -1048.376)">
                <path id="Path_497" data-name="Path 497" d="M4.918,0S0,.425,0,8.646V32.807" transform="matrix(0.848, -0.53, 0.53, 0.848, 858.663, 1051.606)" fill="none" stroke="#fff" strokeWidth="1.4"/>
                <path id="Path_498" data-name="Path 498" d="M4.917,32.807S0,32.382,0,24.161V0" transform="matrix(-0.848, -0.53, 0.53, -0.848, 861.095, 1079.426)" fill="none" stroke="#fff" strokeWidth="1.4"/>
            </g>
        </svg>
    );
}